<template>
    <div class="page-warpper flex flex-direction">
        <header-menu-modular></header-menu-modular>
        <div class="container flex-sub">
            <div class="page-nav flex align-center justify-between margin-top-sm">
                <div class="flex align-center">
                    <div class="page-nav margin-right-xs">当前位置：益宣宝 <span class="margin-lr-xs">></span>{{ title }}</div>
                </div>
                <div>欢迎 <b>{{ user.mnickname }}</b> ，使用益宣宝！</div>
            </div>
            <div class="page-container flex flex-sub">
                <menu-modular :navIndex="navIndex"></menu-modular>
                <div class="content-container">
                    <router-view  @setIndex="getIndex(arguments)" class="content" ></router-view>
                </div>
            </div>
        </div>
        <footer-modular></footer-modular>
        <router-link to="/web/version">
            <img v-if="isNew" class="version" src="../../assets/img/icon_version.png"/>
            <img v-else class="version" src="../../assets/img/icon_version.png"/>
        </router-link>
        <version-detail-dialog :detailDialogVisible="detailDialogVisible" :nid="0"
                               @watchState="watchState"></version-detail-dialog>
    </div>
</template>

<script>

import MenuModular from "@/views/web/components/MenuModular";
import HeaderMenuModular from "@/views/web/components/HeaderMenuModular";
import FooterModular from "@/views/web/components/FooterModular";
import config from '/package.json'
import VersionDetailDialog from "@/views/web/components/VersionDetailDialog";
export default {
    name: "Home",
    components: {
        VersionDetailDialog,
        FooterModular,
        HeaderMenuModular,
        MenuModular
    },
    data() {
        return {
            navIndex: [0],
            title: '',
            menuVisible: true,
            isNew: false,
            detailDialogVisible: false,
        }
    },
    created() {
        let _version = window.localStorage.getItem('version') || '1.0.0'
        this.isNew = config.version > _version
        if (this.isNew) {
            window.localStorage.setItem('version', config.version);
            this.detailDialogVisible = true
        }

    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        getIndex(data) {
            this.navIndex = data[0]
            this.title = data[1]
            this.$nextTick(() => {
                this.$forceUpdate()
            })
        },
        watchState() {
            this.detailDialogVisible = false;
        },
    }

}
</script>

<style lang="scss" scoped>
.page-warpper {
    height: 100vh;
    background: #ebeff5;
    overflow-y: auto;

    .container {
        display: flex;
        flex-direction: column;
        width: 1200px;
        margin: 0 auto;

        .page-nav {
            font-size: 16px;
            color: #0a2240;
        }

        .page-container {
            margin: 15px 0;

            .content-container {
                display: flex;
                flex-direction: column;
                width: calc(100% - 180px);
                background-color: #0a2240;
                border-radius: 10px;
                padding: 20px;
                margin-left: 10px;

                .content {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                }
            }
        }

    }


    .version {
        position: fixed;
        bottom: 150px;
        right: 70px;
        width: 80px;
    }
}
</style>
